import React from 'react';
import s from '../pages.scss';
import {
  SkeletonLine,
  SkeletonCircle,
  Box,
  Layout,
  Cell,
} from '@wix/design-system';

export function SkeletonAppBox() {
  return (
    <Box width="270px" height="215px">
      <Layout className={s.appBoxSkeleton} rowHeight="55px">
        <Cell span={12}>
          <SkeletonCircle diameter="42px" />
          <SkeletonLine width="168px" marginTop="12px" />
        </Cell>
        <Box width="fit-content">
          <Cell>
            <SkeletonLine width="236px" marginBottom="6px" />
            <SkeletonLine width="117px" />
            <Box marginTop="50px" verticalAlign="space-between">
              <SkeletonLine width="80px" />
              <SkeletonLine width="60px" marginRight="5px" />
            </Box>
          </Cell>
        </Box>
      </Layout>
    </Box>
  );
}
